import script from "./ViewGoToResults.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewGoToResults.vue?vue&type=script&setup=true&lang=js"

import "./ViewGoToResults.vue?vue&type=style&index=0&id=2286cfd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2286cfd1"]])

export default __exports__